module.exports = __webpack_public_path__ + "assets/img/home-banner-background.17c67d2b.png";